import { createSelector } from 'reselect';
import getJobListing from './getJobListing';

/**
 * Gets the job function name for a specific job listing.
 * @param {Object} state the application state
 * @param {String|Number} jobListingId the ID for the job listing.
 * @return {String} the function name for the job listing, if found.
 */
export default createSelector(
  getJobListing,
  (jobListing) => jobListing && jobListing.get('jobFunctionName'),
);
